import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import HeaderSection from "../../components/headerSection/HeaderSection";
import DataProvider from "../../components/dataProvider/DataProvider";
import Features from "../../components/features/Features";
import Testimonials from "../../components/testimonials/Testimonials";
import CtaBanner from "../../components/ctaBanner/CtaBanner";
import Footer from "../../components/footer/Footer";

function Home() {
  const location = useLocation();

  useEffect(() => {
    // Wenn von einer anderen Seite zur Homepage navigiert wird mit scrollTo state
    if (location.state?.scrollTo) {
      setTimeout(() => {
        const element = document.getElementById(location.state.scrollTo);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
      
      // State clearen nach dem Scroll
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  return (
    <div>
      <HeaderSection />
      <Testimonials />
      <Features />
      <DataProvider />
      <CtaBanner />
      <Footer />
    </div>
  );
}

export default Home;
